import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from './app.service';
import { MetatagsService } from './components/seo-sitemap/metatags.service';
import { seoSitemap } from './components/seo-sitemap/seo-sitemap';
import { HomePageService } from '../api/services/home-page.service';
import { HomePageListResponseDataItem, PageListResponseDataItem } from 'src/api/models';
import { PageService } from 'src/api/services/page.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { retryWhen } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.scss'
  ],

})

export class AppComponent implements OnInit {
  constructor(
    public hpService: HomePageService,
    public pageService: PageService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public router: Router, public appService: AppService, public metatagsService: MetatagsService) {
    this.sub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setMetaTags(event);
      }
    });
  }
  sub: Subscription;
  appIsLoad: boolean;
  pageList: Array<PageListResponseDataItem>;

  ngOnDestroy() { this.sub && this.sub.unsubscribe(); }

  private setMetaTags(event: NavigationEnd) {
    const item = seoSitemap.find((i) => event.urlAfterRedirects === i.customUrl);
    if (item) {
      if (item.title) { this.metatagsService.updateTitle(item.title); }

      this.metatagsService.updateTags([
        item.description ? { name: 'description', content: item.description } : null,
        item.image ? { name: 'image', content: item.image } : null,
        item.keywords ? { name: 'keywords', content: item.keywords } : null
      ]);
      if (item.keywords == null) {
        this.metatagsService.removeTag('name= "keywords"');
      }
      if (item.description == null) {
        this.metatagsService.removeTag('name= "description"');
      }
      this.metatagsService.removeTag('name= "robots"');

      this.metatagsService.updateTag({ property: 'og:url', content: window.location.href });
    }
  }
  search(searchText: string) {
    this.router.navigate(['/search'], { queryParams: { search: searchText } });
  }

  getMenuPages(isTopMenu: boolean) {
    return isTopMenu ? this.pageList.filter(x => x.attributes.InTopMenu === true) :
      this.pageList.filter(x => x.attributes.InBottomMenu === true);
  }
  ngOnInit() {
    this.appService.showLoader = false;
    const params = {
      populate: '*'
    }
    this.hpService.getHomePage(params).subscribe(result => {
      this.appService.indexData = (result.data as HomePageListResponseDataItem);
      this.metatagsService.updateTitle(this.appService.indexData.attributes.HeaderTitle);
    });

    this.fillPages();
  }
  fillPages() {
    const qs = require('qs');
    const fields = ['InBottomMenu', 'InTopMenu', 'SysName', 'Title', 'Position'];
    const query = qs.stringify(
      {
        fields: fields,
        populate: {
          child_pages: {
            fields: fields,
            populate: {
              child_pages: {
                fields: fields,
              },
              parent_page: {
                fields: fields,
              }
            }
          },
          parent_page: {
            fields: fields,
          }
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    const req = this.http.get<any>(this.appService.apiConfig.rootUrl + '/pages?' + query).subscribe(res => {
      this.pageList = res.data.sort((a, b) => a.attributes.Position - b.attributes.Position);
      this.pageList = this.pageList.map(x => {
        x.attributes.child_pages.data = x.attributes.child_pages.data.sort((a, b) => (a as PageListResponseDataItem).attributes.Position - (b as PageListResponseDataItem).attributes.Position);
        return x;
      })
    });
  }
}

